import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { routes } from '../../consts/routes';
import { WebsiteAnalyzeService } from 'src/app/services/common/website-analyze/website-analyze.service';
import { DataService } from 'src/app/services/common/sidabar/Data.service';
import { SenderVarService } from 'src/app/services/senderVar.service';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
  showFiller = false;
  public routes: typeof routes = routes;
  public isOpenUiElements = false;
  public routeHome: string;
  public routeHomePathFirstParty: string;
  show: boolean;
  isDemo: boolean = false;
  isFPD: boolean = false;
  showFirstPartyDetailSidebar: boolean;
  public isAdmin: boolean = false;
  isPageOnly: boolean = false;
  url: string | null;
  expandPanel: boolean;
  projectHasFPD = false;

  private routerEventsSub: Subscription;

  public openUiElements() {
    this.isOpenUiElements = !this.isOpenUiElements;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private websiteAnalyzeService: WebsiteAnalyzeService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private senderVarService: SenderVarService,
  ) {}

  ngOnInit(): void {
    this.applyRouteSidebarState();
    this.routerEventsSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        this.applyRouteSidebarState();
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
  }

  private resolveProjectId(): string | null {
    return this.senderVarService.resolveProjectIdFrom(this.route, this.router);
  }

  private applyRouteSidebarState(): void {
    const path = this.router.url.split('?')[0];

    if (
      path === '/home' ||
      path === '/home/' ||
      path === '/home/pageLoad/new' ||
      path === '/buyPlan' ||
      path === '/home/myAccount' ||
      path === '/home/pageLoad/loading' ||
      path.includes('diff-alert')
    ) {
      this.show = false;
    } else {
      this.show = true;
    }

    if (path.slice(0, 5) === '/demo') {
      this.routeHome = '/demo/project/';
      this.isDemo = true;
    } else {
      this.url = this.resolveProjectId();
      this.routeHome = this.url ? `/home/page/${this.url}` : '';
      this.isDemo = false;
      this.expandPanel = path.includes('home/page');
      this.routeHomePathFirstParty = this.url ? `/home/rum/${this.url}` : '';
      this.showFirstPartyDetailSidebar = ['rum', 'home/page'].some((p) =>
        path.includes(p),
      );
    }

    if (path.split('/').pop() === 'rum') {
      this.showFirstPartyDetailSidebar = false;
      this.show = false;
    }
    this.isPageOnly = path.includes('-po');

    const projectId = this.resolveProjectId();
    if (projectId) {
      void this.loadProjectFpdFlag(projectId);
    } else {
      this.projectHasFPD = false;
    }
  }

  private async loadProjectFpdFlag(projectId: string): Promise<void> {
    try {
      const website = await this.websiteAnalyzeService
        .getProjectByProjectId(projectId)
        .toPromise();
      this.projectHasFPD = !!website?.isFPDEnabled;
      this.cdr.markForCheck();
    } catch {
      this.projectHasFPD = false;
      this.cdr.markForCheck();
    }
  }
}
